.loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.section {
  margin-bottom: 24px;
}

.recap {
  margin-top: 16px;
}

.json {
  max-height: 400px;
  padding: 12px;
  margin: 0;
  overflow: auto;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 13px;
  color: var(--ant-color-text);
  white-space: pre-wrap;
  background: var(--ant-color-fill-quaternary);
  border-radius: var(--ant-border-radius-sm);
}
